
export default {
  props: {
    value: {
      default: false,
    },
    checkboxId: {
      default: 'cbx-46',
    },
    required: {
      default: false,
      type: Boolean,
    },
  },
}
